<ng-container *ngIf="marketplaceService.userHasFeedback(user); else noFeedbackTemplate">
  <div class="feedback">
    <div class="stars">
      <ng-container *ngFor="let star of stars">
        <fa-icon *ngIf="star === 2" [icon]="['fas', 'star']"></fa-icon>
        <fa-icon *ngIf="star === 1" [icon]="['fas', 'star-half-stroke']"></fa-icon>
        <fa-icon *ngIf="star === 0" [icon]="['far', 'star']"></fa-icon>
      </ng-container>
    </div>
  </div>

  <div class="feedback-label">
    {{ "Current feedback" | translate }}:
    <a [routerLink]="['/equipment/marketplace/users', user.username, 'feedback']">
      {{ user.marketplaceFeedback | number: "1.0-2" }}%
    </a>
  </div>
</ng-container>

<div *ngIf="showLeaveFeedbackButton" class="mt-3 text-center">
  <button (click)="showFeedbackModal()" class="btn btn-primary">
    <ng-container *ngIf="alreadyHasFeedbackFromCurrentUser">
      {{ "Edit feedback" | translate }}
    </ng-container>
    <ng-container *ngIf="!alreadyHasFeedbackFromCurrentUser">
      {{ "Leave feedback" | translate }}
    </ng-container>
  </button>
</div>

<ng-template #noFeedbackTemplate>
  <div class="alert alert-info mb-0">
    {{ "This user has no feedback yet." | translate }}
  </div>
</ng-template>
